import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import ClearOutlinedIcon
    from "@material-ui/icons/ClearOutlined";
import apiHelper from "../../../../../util/ApiHelper";
import {toast} from "react-toastify";
import {modal} from "../../../../../util";
import styled from "styled-components";

const useStylesAll = makeStyles((theme) => ({
    root: {
        margin: 0,
        marginBottom: 20,
    },
    leftGrid: {
        maxHeight: 100,
    },
    last: {
        margin: 0,
        marginTop: 47,
    },
    topBar: {
        padding: 0,
    },
    pagination: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
    "&::placeholder": {
        color: "grey",
    },
}));

const A = styled.a`
  color: #306F9D;
  text-decoration: none;
`;


export default function TagsForm({disabled, ...props}) {
    const {history, fetchData} = props;
    const classes = useStylesAll();
    let {id} = useParams();
    const {
        control,
        register,
        handleSubmit,
        setValue
    } = useForm();
    const [currImage, setCurrImage] = useState("");
    const [fileName, setFileName] = useState("");
    const [seq, setSeq] = useState(0);

    useEffect(() => {
        register("file");
    }, [register]);

    useEffect(() => {
        if (id) {
            apiHelper.cinefan
                .getTagById(id)
                .then((response) => {
                    console.log(response.data);
                    setCurrImage(response.data.image);
                    setValue("title", response.data.title);
                    setSeq(response.data.seq);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }, []);

    useEffect(() => {
        if (props.data) {
            setCurrImage(props.data.image);
            setValue("engName", props.data.localizations.en.content);
            setValue("tcName", props.data.localizations.tc.content);
            setValue("googleMapUrl", props.data.url);
        }
    }, []);

    const handleChange = (e) => {
        setValue("file", e.target.files); // you get all the files object here
        if (e.target.files[0]) setFileName(e.target.files[0].name);
    };

    const handleDeleteImage = async () => {
        const decision = await modal.fire({
            title: "Delete Entry Application",
            text: "Are you sure to delete the current tag image?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            setCurrImage("");
        }
    };

    const handleDeleteTag = async () => {
        const decision = await modal.fire({
            title: "Delete Tag",
            text: "Are you sure to delete the current tag?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            try {
                const result = await apiHelper.cinefan.deleteTagById(id);
                console.log(result.data);
                history.push("/cinefan/movies/tags");
            } catch (err) {
                console.log(err);
            }
        }
    };

    const createMovieTag = async (data, image) => {
        try {
            await apiHelper.cinefan.createTag(
                props.formatRowToData(data, props.minSeq(), image)
            );
            toast.dark("Movie tag created.");
            setCurrImage("");
            setValue("title", "");
            setFileName("");
            setSeq(0);
            fetchData();
        } catch (err) {
            console.log(err);
        }
    };

    const updateMovieTag = async (data, image) => {
        try {
            const result = await apiHelper.cinefan.updateTagById(
                id,
                props.formatRowToData(data, seq, image)
            );
            console.log(result.data);
            history.push("/cinefan/movies/tags");
            toast.dark("Your changes is saved.");
        } catch (err) {
            console.log(err);
        }
    };

    const onSubmit = (data) => {
        let image = "";
        const sendTag = () => {
            if (id) {
                if (!image && currImage) {
                    image = currImage;
                }
                updateMovieTag(data, image);
            } else {
                createMovieTag(data, image);
            }
        };
        if (data.file) {
            apiHelper.cinefan
                .uploadFile(data.file[0])
                .then((response) => {
                    console.log(response.data);
                    image = response.data.url;
                })
                .then(() => {
                    sendTag();
                })
                .catch((error) => console.log(error));
        } else {
            sendTag();
        }
    };

    return (
        <>
            <Box fontWeight={900} fontSize={13} mb={2}
                 width="100%">
                <Typography
                    variant="p">{props.description}</Typography>
            </Box>
            <form autoComplete="off"
                  onSubmit={handleSubmit(onSubmit)}>
                <fieldset disabled={disabled}
                          className="fieldset">
                    <Box width="100%">
                        <Controller
                            control={control}
                            name="title"
                            defaultValue=""
                            render={({field}) => {
                                return (
                                    <TextField
                                        id="outlined-basic"
                                        className={classes.root}
                                        label="Title"
                                        variant="outlined"
                                        helperText="The title is how it appears on your site."
                                        {...field}
                                        fullWidth
                                        required
                                    />
                                );
                            }}
                        />

                        <TextField
                            htmlFor="raised-button-file"
                            label={
                                fileName ? (currImage ? "Change Tag Image" : "Tag Image") : ""
                            }
                            className={classes.root}
                            value={fileName ? fileName : ""}
                            variant="outlined"
                            helperText={
                                currImage ? "" : "The image will display as tag icon."
                            }
                            placeholder={currImage ? "Change Tag Image" : "Tag Image"}
                            fullWidth
                            required={!currImage}
                            InputProps={{
                                classes: {
                                    input: classes["&::placeholder"],
                                },
                                endAdornment: (
                                    <Controller
                                        control={control}
                                        name="file"
                                        render={({field}) => {
                                            return (
                                                <InputAdornment
                                                    position="end">
                                                    <input
                                                        style={{display: "none"}}
                                                        id="raised-button-file"
                                                        type="file"
                                                        onChange={handleChange}
                                                    />
                                                    <Button
                                                        htmlFor="raised-button-file"
                                                        variant="outlined"
                                                        component="label"
                                                    >
                                                        Choose
                                                    </Button>
                                                </InputAdornment>
                                            );
                                        }}
                                    />
                                ),
                                startAdornment: (
                                    <InputAdornment
                                        position="start"
                                        style={fileName ? {} : {display: "none"}}
                                    >
                                        <IconButton
                                            component="label"
                                            size="small"
                                            onClick={() => {
                                                setValue("file", null);
                                                setFileName("");
                                            }}
                                        >
                                            <ClearOutlinedIcon
                                                fontSize="inherit"/>
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            style={currImage ? {marginBottom: "0"} : {}}
                        />

                        {currImage ? (
                            <p>
                                <img
                                    src={currImage}
                                    style={{
                                        maxHeight: "30px",
                                        maxWidth: "30px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => window.open(currImage, '_blank').focus()}
                                    alt=""
                                />
                                &nbsp;
                                <A href={currImage}
                                   target="_blank"><small>{currImage.split("/").pop()}</small></A>
                                {disabled || (
                                    <small
                                        style={{
                                            marginLeft: "20px",
                                            textDecoration: "underline",
                                            color: "#962013",
                                            cursor: "pointer",
                                        }}
                                        onClick={handleDeleteImage}
                                    >
                                        Delete
                                    </small>
                                )}
                            </p>
                        ) : (
                            ""
                        )}
                        <Box display="flex"
                             alignItems="flex-end"
                             alignContent="flex-end">
                            <Box>
                                {disabled || (
                                    <Button
                                        className={classes.last}
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        type="submit"
                                    >
                                        {props.submitBtnTxt}
                                    </Button>
                                )}
                            </Box>
                            {id && !disabled ? (
                                <Box>
                                    <small
                                        style={{
                                            marginLeft: "20px",
                                            color: "#962013",
                                            cursor: "pointer",
                                        }}
                                        onClick={handleDeleteTag}
                                    >
                                        Delete Tag
                                    </small>
                                </Box>
                            ) : (
                                <></>
                            )}
                        </Box>
                    </Box>
                </fieldset>
            </form>
        </>
    );
}
